import { useSteps } from 'src/hooks';
import { useDataContext } from 'src/contexts';
import { StepsEnum } from 'src/types';
import {
  InitializationStep,
  LookAtPlayWallStep,
  ResultStep,
  CapturedStep,
} from './steps';

const stepsConfig = [
  {
    key: StepsEnum.INITIALIZATION,
    Component: InitializationStep,
    shouldAnimate: true,
  },
  {
    key: StepsEnum.LOOK_AT_PLAY_WALL,
    Component: LookAtPlayWallStep,
    shouldAnimate: false,
  },
  {
    key: StepsEnum.CAPTURED,
    Component: CapturedStep,
    shouldAnimate: true,
  },
  {
    key: StepsEnum.RESULT,
    Component: ResultStep,
    shouldAnimate: true,
  },
];

export const useMain = () => {
  const { activeStep, previousStep } = useSteps();

  const hasMedia = useDataContext((ctx) => ctx.hasMedia ?? false);
  const recordingStartedByMe = useDataContext(
    (ctx) => ctx.recordingStartedByMe ?? false
  );

  const activeIndex = stepsConfig.findIndex((step) => step.key === activeStep);

  const previousStepIndex =
    previousStep !== null
      ? stepsConfig.findIndex((step) => step.key === previousStep)
      : -1;

  return {
    hasMedia,
    recordingStartedByMe,
    activeIndex,
    previousStepIndex,
    steps: stepsConfig,
  };
};
